module.exports = __webpack_public_path__ + "static/media/music.8ff87aa8.svg";